<template>
  <bar :chartdata="chartdata" :options="options"/>
</template>

<script>
import Bar from '@/components/charts/bar'

export default {
  name: 'ToolsFailedPipeline',
  components: {
    Bar
  },
  props: {
    pipelines: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      chartdata: null,
      options: {
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Count'
            },
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        }
      }
    }
  },
  methods: {
    fillchartdata: function () {
      const dataset = []
      const labels = []

      for (const pipeline in this.pipelines) {
        labels.push(pipeline)
        dataset.push(this.pipelines[pipeline].length)
      }

      this.chartdata = {
        labels: labels,
        datasets: [{
          label: 'pipelines',
          data: dataset,
          backgroundColor: '#118ab2'
        }]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ToolsFailedPipeline.vue